import React from "react"
import { useParams } from "react-router-dom"
import AdminRewards from "../Rewards/Rewards"

/**
 * Manage City — Rewards listing.
 * GET /api/v1/admin/rewards?city_id=
 */
const AdminCityRewards = () => {
  const { cityId } = useParams()

  return (
    <AdminRewards
      documentTitle="Treasure | AMOK . EARTH Admin"
      detailBasePath={`/admin/cities/${cityId}/rewards`}
      cityId={cityId}
      showKpi={false}
      showExport={false}
      showSearch
      showFilter
    />
  )
}

export default AdminCityRewards
